import { render, staticRenderFns } from "./SelectFromReestrModal.vue?vue&type=template&id=4b640c96"
import script from "./SelectFromReestrModal.vue?vue&type=script&lang=js"
export * from "./SelectFromReestrModal.vue?vue&type=script&lang=js"
import style0 from "./SelectFromReestrModal.vue?vue&type=style&index=0&id=4b640c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports